import './polyfills'

import { configure, bootstrapApp } from './main'

configure()
bootstrapApp('root')
